import { useState, createContext, useMemo, useEffect } from "react";
import log from "loglevel";
import { AUTH_STATUS } from "constants/auth";

const UserContext = createContext({
  user: null,
  setUser: () => {},
  authStatus: AUTH_STATUS.CHECKING,
  setAuthStatus: () => {},
});

const UserProvider = ({ children }) => {
  log.debug('CONTEXT_USER_PROVIDER');
  const [user, setUser] = useState(null);
  const [authStatus, setAuthStatus] = useState(AUTH_STATUS.CHECKING);

  const value = useMemo(() => ({
    user,
    setUser,
    authStatus,
    setAuthStatus,
  }), [user, authStatus]);

  return (
    <UserContext.Provider value={value}>{children}</UserContext.Provider>
  );
};

export { UserProvider };

export default UserContext;
